export default {
      id: "oc-saas-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-saas",
      toString: function () {
        return this.url;
      }
    }